// global
import React, { memo } from 'react';
import PropTypes from 'prop-types';
// icons
import ArrowIcon from 'assets/icon/arrow-icon/ArrowIcon';
import LoadingIcon from 'assets/icon/loading-icon/LoadingIcon';
import ProblemIcon from 'assets/icon/problem-icon/ProblemIcon';
//stylesheet
import styles from './Icon.module.scss';

function Icon({ size, loading, error }) {
  return (
    <div className={`${styles[size]}`}>
      {error && <ProblemIcon fill='#C9252D' className={styles.errorIcon} />}
      {!loading && <ArrowIcon size='15' direction='down' />}
      {loading && <LoadingIcon size='15' fill='#4B4B4B' />}
    </div>
  );
}

Icon.defaultProps = {
  size: 'medium',
  loading: false,
  error: false
};

Icon.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default memo(Icon);
